import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '', confirmPassword: '', inviteCode: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('A jelszavak nem egyeznek');
      return;
    }
    if (form.password.length < 6) {
      setError('A jelszó legalább 6 karakter legyen');
      return;
    }
    setLoading(true);
    try {
      await register(form.username, form.password, form.inviteCode);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Hiba történt');
    } finally {
      setLoading(false);
    }
  }

  const field = (key, label, type = 'text', placeholder = '') => (
    <div>
      <label className="block text-sm text-slate-400 mb-1">{label}</label>
      <input
        className="input"
        type={type}
        placeholder={placeholder}
        value={form[key]}
        onChange={(e) => setForm({ ...form, [key]: e.target.value })}
        required
      />
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none select-none text-8xl flex flex-wrap gap-8 p-8 overflow-hidden">
        {Array.from({ length: 40 }).map((_, i) => (
          <span key={i}>{['🃏','🎰','🎲','♠','♥','♦','♣'][i % 7]}</span>
        ))}
      </div>

      <div className="card w-full max-w-sm mx-4 relative z-10">
        <h1 className="text-2xl font-bold text-center mb-1">
          <span className="text-yellow-400">Csaba</span>Casino
        </h1>
        <p className="text-slate-400 text-center text-sm mb-6">Regisztráció – invite kód szükséges</p>

        {error && (
          <div className="bg-red-500/10 border border-red-500/30 text-red-400 rounded-lg px-3 py-2 text-sm mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {field('inviteCode', 'Invite kód', 'text', 'XXXXXXXXXXXXXX')}
          {field('username', 'Felhasználónév')}
          {field('password', 'Jelszó', 'password')}
          {field('confirmPassword', 'Jelszó megerősítése', 'password')}
          <button className="btn-gold w-full" type="submit" disabled={loading}>
            {loading ? 'Regisztráció...' : 'Regisztráció'}
          </button>
        </form>

        <p className="text-center text-sm text-slate-500 mt-4">
          Már van fiókod?{' '}
          <Link to="/login" className="text-yellow-400 hover:underline">Bejelentkezés</Link>
        </p>
      </div>
    </div>
  );
}
